const DATE_INPUT_FORMAT_SHORT = 'ddMM'
const DATE_INPUT_FORMAT_SEMI = 'ddMMyy'
const DATE_INPUT_FORMAT_FULL = 'ddMMyyyy'

export const getDateFormat = (inputValue: string) => {
  if (inputValue.length === DATE_INPUT_FORMAT_SHORT.length) {
    return DATE_INPUT_FORMAT_SHORT
  }

  if (inputValue.length === DATE_INPUT_FORMAT_SEMI.length) {
    return DATE_INPUT_FORMAT_SEMI
  }

  return DATE_INPUT_FORMAT_FULL
}
